<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table :data="users_repaired">
      <el-table-column
        prop="area_name"
        show-overflow-tooltip
        mid-width="5%"
        align="center"
        label="区域名称"
      />

      <el-table-column
        prop="users.mobile"
        show-overflow-tooltip
        width="150"
        align="center"
        label="用户手机号"
      />
      <el-table-column
        prop="bike_no"
        show-overflow-tooltip
        width="150"
        align="center"
        label="车牌号"
      />
      <el-table-column
        prop="created_at"
        show-overflow-tooltip
        width="220"
        align="center"
        label="创建时间"
      />
      <el-table-column
        prop="trouble_part"
        width="150"
        align="center"
        show-overflow-tooltip
        label="故障部位"
      />
      <el-table-column
        prop="trouble_description"
        :show-overflow-tooltip="true"
        label="故障描述"
      />
      <el-table-column
        label="是否已读"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status"
            type="success"
          >已读</el-tag>
          <el-tag
            v-else
            type="danger"
          > 未读</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="100"
        align="center"
      >
        <template #default="{ row, $index }">
          <el-button @click="ditailClick(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="25%"
    >
      <el-dialog
        width="30%"
        title="报修图片"
        :visible.sync="innerVisible"
        :append-to-body="true"
      >
        <img
          v-for="(i,key) in rows.fix_image"
          :key="key"
          :src="i.url"
          alt="测试"
          style="width:30%;"
        >
      </el-dialog>
      <div class="info-wrp">
        <div class="title">故障信息</div>
        <div class="info-item">
          <span>车牌号：</span> <span>{{ rows.bike_no }}</span>
        </div>
        <div class="info-item">
          <span>报修用户：</span> <span>{{ rows.nickname }}</span>
        </div>
        <div class="info-item">
          <span>报修用户手机：</span> <span>{{ rows.mobile }}</span>
        </div>
        <div class="info-item"><span>报修时间：</span> <span>{{ rows.created_at }}</span></div>
        <div class="info-item">
          <span>报修部位：</span> <span>{{ rows.trouble_part }}</span>
        </div>
        <div class="info-item">
          <span>报修详情：</span> <span style="width:70%;">{{ rows.trouble_description }}</span>
        </div>
        <div class="info-item">
          <span>报修图片：</span> <span
            v-show="is_img_show"
            @click="clickImgShow"
            style="color:green;"
          >
            点击查看图片
          </span>
        </div>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getUserRepaired, getUserRepairedImg } from "@/api/user-repaired";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        },
        {
          field: "bike_no",
          label: "车牌号"
        }
      ],
      users_repaired: [],
      page: null,
      dialogVisible: false,
      innerVisible: false,
      rows: {
        bike_no: "",
        nickname: "",
        mobile: "",
        created_at: "",
        trouble_part: "",
        trouble_description: "",
        fix_image: []
      },
      imgIds: [],
      is_img_show: false
    };
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(55, newVal);
        const {
          data: { data, meta }
        } = await getUserRepaired(newVal.query);
        this.users_repaired = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[3].options.push.apply(
          this.search[3].options,
          merchant.data
        );
      }
    } 
  },
  methods: {
    ditailClick(row) {
      // 详情

      this.rows.bike_no = row.bike_no;
      this.rows.nickname = row.users.nickname;
      this.rows.mobile = row.users.mobile;
      this.rows.created_at = row.created_at;
      this.rows.trouble_part = row.trouble_part;
      this.rows.trouble_description = row.trouble_description;
      this.rows.fix_image = JSON.parse(row.trouble_imgs);
      console.log(this.rows.fix_image);
      this.imgIds = JSON.parse(row.trouble_imgs);
      if (this.rows.fix_image != null) {
        this.is_img_show = true;

        // const [{ data: imgs }] = await Promise.all([
        //   getUserRepairedImg({ imgIds: this.imgIds }),
        // ])
        // this.rows.fix_image = imgs
      }
      this.dialogVisible = true;
    },
    async clickImgShow() {
      this.innerVisible = true;
      const [{ data: imgs }] = await Promise.all([
        getUserRepairedImg({ imgIds: this.imgIds })
      ]);
      this.rows.fix_image = imgs;
      console.log(imgs);
    }
  }
};
</script>
<style lang="scss" scope>
.info-wrp {
  margin-top: -50px;
}
.info-wrp .title {
  font-size: 16px;
  margin: 40px 0 10px;
  padding-top: 10px;
  border-top: 1px solid #ccc;
}
.info-wrp .info-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}
.info-wrp .info-item > span:first-child {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.info-wrp .pic-wrp > div:first-child {
  width: 120px;
  text-align: right;
}
</style>
